export default __webpack_public_path__ + "assets/models/1bdab07937e85bcdc7e1e871e1063f37.glb";